import React from 'react';
import { Checkbox, TableCell, TableHead, TableRow, TableSortLabel } from '@material-ui/core';
const headers = [
    { id: 'file.name', label: 'Name' },
    { id: 'task.key', label: 'ID' },
    { id: 'file.version', label: 'Version' },
    { id: 'file.modifiedBy', label: 'Modified By' },
    { id: 'file.modified', label: 'Last Modified' },
    { id: 'task.status', label: 'Status' }
];
const DocumentListHead = props => {
    const { orderBy, checkboxProps, onSort, onToggleAll } = props;
    const order = props.order.toLowerCase();
    return (React.createElement(TableHead, null,
        React.createElement(TableRow, null,
            React.createElement(TableCell, { padding: 'checkbox' },
                React.createElement(Checkbox, Object.assign({ color: 'primary' }, checkboxProps, { onChange: (_, checked) => onToggleAll === null || onToggleAll === void 0 ? void 0 : onToggleAll(checked) }))),
            headers.map(item => (React.createElement(TableCell, { key: item.id, sortDirection: orderBy === item.id ? order : false },
                React.createElement(TableSortLabel, { active: orderBy === item.id, direction: orderBy === item.id ? order : 'asc', onClick: () => onSort === null || onSort === void 0 ? void 0 : onSort(item.id) }, item.label)))))));
};
export default DocumentListHead;
//# sourceMappingURL=DocumentListHead.js.map